import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class HousekeepingViewModel {
    ShowAlert:      (pTitle: string, pMessage: string) => void;
    BackToSignIn:   ()                                 => void;
    ReloadMenu:     ()                                 => void;
    NewLoading:     (pMessage: string)                 => dmLoading;

    mlText:         MLText;
    app:            mlBroker;
    ml:             mlBroker;
    Hotel:          dmHotel;
    LangID:         number;

    Settings:       RQService.Pms.GetCTMAccountSettingsRow;

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pReloadMenu:   ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText          = pMLText;
        this.LangID          = this.mlText.GetLangID();
        this.app             = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml              = this.mlText.GetBroker(
            'HotelAreaHousekeeping'
        );

        this.Hotel           = pHotel;
        this.BackToSignIn    = pBackToSignIn;
        this.ReloadMenu      = pReloadMenu;
        this.ShowAlert       = pShowAlert;
        this.NewLoading      = pNewLoading;

        this.Settings        = RQService.Pms.PopulateGetCTMAccountSettingsRow({ });
        this.Settings.APIKey = '';

        let loading          = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshSettings(() => { loading.Dismiss(); });
        });
    }

    private refreshSettings(pAction: () => void): void {
        let settingsParams = RQParam.PmsGetCTMAccountSettingsParams();

        settingsParams.HotelID = this.Hotel.HotelID;

        RQService.Pms.GetCTMAccountSettings(settingsParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pAction(); return; }

            let settings = response.RQueryResult;

            if (settings.length > 0) {
                this.Settings = RQService.Pms.PopulateGetCTMAccountSettingsRow(
                    settings[0]
                );
            } else {
                this.Settings        = RQService.Pms.PopulateGetCTMAccountSettingsRow({ });
                this.Settings.APIKey = '';
            }

            pAction();
        });
    }

    public ActivateHousekeeping(): void {
        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let activateParams = RQParam.PmsInitOTAHotelCTMAccountParams();

            activateParams.HotelID = this.Hotel.HotelID;

            RQService.Pms.InitOTAHotelCTMAccount(activateParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.Hotel.HotelInfo.ServiceTypeID = 3;
                this.Hotel.WithHousekeeping        = true;

                this.refreshSettings(() => {
                    loading.Dismiss();

                    this.ReloadMenu();
                });
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/housekeeping/xv-housekeeping.ts